"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_shuffle_1 = __importDefault(require("lodash.shuffle"));

function shuffle(collection) {
  return lodash_shuffle_1.default(collection);
}

exports.shuffle = shuffle;